module.exports = __webpack_public_path__ + "media/img/contact-bg-f2b18d9c.jpg";